// Wird zur Build-Zeit von Vue CLI aus der Env-Var VUE_APP_VERSION ersetzt
// (gesetzt in deploy.sh). Im lokalen `npm run serve` ist sie nicht gesetzt
// -> Fallback "dev".
export const APP_VERSION: string = process.env.VUE_APP_VERSION || 'dev';
